import { CpInsuredPersonModel } from '../insured-person/cp-insured-person-model';
import { SetupRefundsInterface } from '../../../interfaces/dto/setup-refunds/setup-refunds-interface';
import { CpRefundsServicesModel } from '../refunds-services/cp-refunds-services-model';
import { CpRefundsPaymentMethodConfigModel } from '../refunds-payment-method-config/cp-refunds-payment-method-config-model';

export class CpSetupRefundsModel implements SetupRefundsInterface {
  Services: CpRefundsServicesModel[] = new Array<CpRefundsServicesModel>();
  OriginalNeeded: boolean = false;
  ShowClientAreaEmailField: boolean = false;
  ShowClientAreaIbanField: boolean = false;
  PaymentMethodConfig: CpRefundsPaymentMethodConfigModel = new CpRefundsPaymentMethodConfigModel();
  InsuredPersons: CpInsuredPersonModel[] = new Array<CpInsuredPersonModel>();

  constructor(init?: Partial<CpSetupRefundsModel>) {
    Object.assign(this, init);
  }
}
